var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn_refresh copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB300\\uC2DC\\uBCF4\\uB4DC&\\uC11C\\uBE0C",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3P_03\\uB300\\uC2DC\\uBCF4\\uB4DC",
    transform: "translate(-1340.000000, -170.000000)",
    stroke: "#BBBBBB",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uACF5\\uC9C0\\uC0AC\\uD56D",
    transform: "translate(264.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1074.000000, 18.003853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8250526,5.82854971 C14.556273,4.04543661 12.4727864,2.88235294 10.1176471,2.88235294 C6.25165381,2.88235294 3.11764706,6.01635969 3.11764706,9.88235294 C3.11764706,13.7483462 6.25165381,16.8823529 10.1176471,16.8823529 C13.9836403,16.8823529 17.1176471,13.7483462 17.1176471,9.88235294",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: ">",
    transform: "translate(14.425339, 4.497738) rotate(-270.000000) translate(-14.425339, -4.497738) ",
    points: "12.8099548 2.88235294 16.040724 2.88235294 16.040724 6.11312217"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c768a7ca9241a3195b362b4790a5c05e.svg";
export { ForwardRef as ReactComponent };